<template>
    <div class="edit">
        <div class="edit-row">
            <div class="run-btn" v-on:click="runit"><i class="fa fa-play" aria-hidden="true"></i>运行</div>
            <!-- <div class="light-btn" @click="isLighthign=false" v-if="isLighthign">白天模式</div>
            <div class="light-btn" @click="isLighthign =true" v-else>夜晚模式</div> -->
        </div>
        <div class="edit-form">
            <textarea id="yourcode"></textarea>
        </div>
    </div>
</template>

<script>
  import {runit} from '../../static/javascript/skulpt'

  export default {
  name: 'PyEdit',
  data () {
      return {
          isLighthign: true,
          editor: {}
      }
  },
  mounted () {
    var version = '# version: Python3\n\n'
    var codeAreaTip = '# please edit your code here:\n'
    var codeStart = '# code start\n\n'
    var codeEnd = '# code end\n\n'
    var code = 'import turtle\n' +
      'print(\'hello1\')\n' +
      't = turtle.Turtle()\n' +
      't.color(\'red\')\n' +
      't.forward(75)\n\n'
    // document.getElementById('yourcode').value = version + codeAreaTip + codeStart + code + codeEnd
    // eslint-disable-next-line
    let editor = CodeMirror.fromTextArea(document.getElementById('yourcode'), {
      mode: 'python',
      theme: 'leetcode',
      lineNumbers: true,
      keyMap: 'sublime', // 快键键风格
      smartIndent: true, // 智能缩进
      indentUnit: 4, // 智能缩进单位为4个空格长度
      indentWithTabs: true, // 使用制表符进行智能缩进
      lineWrapping: true, //
      // 括号匹配
      gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter', 'CodeMirror-lint-markers'],
      foldGutter: true, // 启用行槽中的代码折叠
      autofocus: true, // 自动聚焦
      matchBrackets: true, // 匹配结束符号，比如"]、}"
      autoCloseBrackets: true, // 自动闭合符号
      styleActiveLine: true // 显示选中行的样式
    })
    editor.setSize('100%', '100%')
    // 编辑器按键监听
    editor.on('keypress', function () {
      // 显示智能提示
      editor.showHint() // 注意，注释了CodeMirror库中show-hint.js第131行的代码（阻止了代码补全，同时提供智能提示）
    })
    this.editor = editor
    // TODO 保存时获取代码
    console.dir(editor.getTextArea().value)
    console.dir(editor)
    // TODO 动态设置代码
/*     editor.setOption('value', `
import turtle
print('hello1')
t = turtle.Turtle()
t.color('red')
t.forward(7888)
    `)
/     editor.save() */
    console.dir(editor.getTextArea().value)
  },
  methods: {
    loadPy(text){
        // this.editor.setOption('value',text)
        // this.editor.save()
        this.editor.getDoc().setValue(text);
        this.editor.refresh();
        this.editor.save()
    },
    getData(){
        return this.editor.getValue()
    },
    saveToLocal(title){
        const blob = new Blob([this.editor.getValue()], {type: 'text/x-python'});
        this.handleDownLoad(title+ '.py',blob)
    },
        // 下载文件的方法
        handleDownLoad(filename, blob) {
                const downloadLink = document.createElement('a');
                document.body.appendChild(downloadLink);
                // Edge浏览器的兼容处理 
                if (navigator.msSaveOrOpenBlob) {
                    navigator.msSaveOrOpenBlob(blob, filename);
                    return;
                }
                const url = window.URL.createObjectURL(blob);
                downloadLink.href = url;
                downloadLink.download = filename;
                downloadLink.type = blob.type;
                downloadLink.click();
                window.URL.revokeObjectURL(url);
                document.body.removeChild(downloadLink);
        },
    runit: function () {
      runit(this.editor)
    },
    lighthigh: function () {

    },
    lightlow: function () {

    }
  }
}
</script>

<style scoped>
    .edit{
        display: inline-block;
        flex: 1;
        height: 100%;
        background-color: white;
        min-width: 500px;
        user-select: none;
        width: 100%;
    }
    .edit-form{
        height:calc(100% - 105px);
        width: 100%;
    }
    .edit>div{
        display: inline-block;
    }
    .edit-row{
        width:100%;
        height: 50px;
        border-bottom:1px solid lightgray;
        background-color: white;
        margin-top: 48px;
    }
    .run-btn{
        margin-left: 20px;
        display: inline-block;
        vertical-align: top;
        margin-top: 9px;
        width: 100px;
        height: 30px;
        border-radius: 20px;
        background-color: rgb(255,219,115);
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        cursor: pointer;
    }
    .run-btn:hover{
        background-color: rgb(246,207,92);
    }
    .run-btn>i{
        margin-right: 5px;
        font-size: 12px;
        color: rgb(99,89,42);
    }
    .light-btn{
        margin-left: 20px;
        display: inline-block;
        vertical-align: top;
        margin-top: 9px;
        width: 100px;
        height: 30px;
        border-radius: 20px;
        background-color: rgb(255,219,115);
        text-align: center;
        line-height: 30px;
        font-size: 14px;
        cursor: pointer;
        float: right;
        margin-right: 20px;
    }

    #yourcode{
        height: 100%;
        width: 100%;
        outline: none;
        resize:none;
        font-size: 26px;
        border: none;
    }
    .CodeMirror {
        height: 100%;
    }

    .CodeMirror-scroll {
        height: auto;
        overflow-y: hidden;
        overflow-x: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/PyEdit.vue